import React, { ComponentProps } from 'react';
import ReactMarkdown from 'react-markdown';

import { PaddedOl, PaddedUl } from './components';

export type MarkdownProps = ComponentProps<typeof ReactMarkdown>;

const defaultComponents: MarkdownProps['components'] = {
  ol: ({ node, ...props }) => {
    return <PaddedOl {...props} />;
  },
  ul: ({ node, ...props }) => {
    return <PaddedUl {...props} />;
  },
};

export const Markdown = ({ components, ...others }: ComponentProps<typeof ReactMarkdown>): JSX.Element => (
  <ReactMarkdown components={{ ...defaultComponents, ...(components ?? {}) }} {...others} />
);
